var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "url(#paint0_linear_3192_1781)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5879 136.424H32.6099L56.9556 65.9009H76.1705L100.482 136.424H84.5038L66.8385 82.0166H66.2876L48.5879 136.424ZM47.5892 108.704H85.3303V120.343H47.5892V108.704ZM133.97 136.424H108.97V65.9009H134.177C141.27 65.9009 147.377 67.3127 152.496 70.1364C157.616 72.9372 161.553 76.9661 164.308 82.2232C167.085 87.4803 168.474 93.7705 168.474 101.094C168.474 108.44 167.085 114.753 164.308 120.033C161.553 125.313 157.593 129.365 152.427 132.189C147.285 135.012 141.133 136.424 133.97 136.424ZM123.881 123.649H133.35C137.758 123.649 141.465 122.868 144.473 121.307C147.503 119.723 149.776 117.278 151.291 113.973C152.829 110.644 153.598 106.351 153.598 101.094C153.598 95.8825 152.829 91.624 151.291 88.3183C149.776 85.0125 147.515 82.579 144.507 81.018C141.5 79.4569 137.792 78.6764 133.385 78.6764H123.881V123.649Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3192_1781",
    x1: 200,
    y1: 200,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1515E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b9211067779d59b5edf600f574fae40d.svg";
export { ForwardRef as ReactComponent };